import {
  GET_DRIVER,
  GET_VEHICLE,
  GET_INTERVENTIONS,
  GET_INTERVENTIONS_HISTORIC,
  GET_NOTIFICATIONS,
  GET_INFO_USER,
  SET_INFO_USER,
  UPDATE_TOWNS_BY_CP_CACHE,
  GET_OPERATIONS_CARD_FUEL,
  RESET_INTERVENTIONS,
  SET_VEHICLE_SELECTED,
  SEND_NOTIFICATION_READED,
  OFFER_LEGAL_CONDITIONS,
  GET_AUTOLOGIN,
  RESET_REMPLACE_VEHICLE,
  UPDATE_TOWNS_BY_PROVINCE_CODE_CACHE
} from 'store/actions/vehicleInfo';
import { setValueObjectByField } from 'helpers/object';

export default {
  [GET_DRIVER]: (state, resp) => {
    state.driverInfo = resp;
  },

  [GET_VEHICLE]: (state, { data }) => {
    state.vehicles.push(data);
  },

  [GET_INTERVENTIONS_HISTORIC]: (state, resp) => {
    if (resp) {
      state.historicalsInterventions = resp;
    }
  },

  [GET_INTERVENTIONS]: (state, resp) => {
    if (resp) {
      const historicalsNextInterventions = resp.filter(
        detail => detail.insurance !== null && detail.insurance !== ''
      );
      if (historicalsNextInterventions.length) {
        state.historicalsNextInterventions = historicalsNextInterventions;
      }
    }
  },

  [RESET_INTERVENTIONS]: state => {
    state.historicalsNextInterventions = null;
    state.historicalsInterventions = null;
  },

  [RESET_REMPLACE_VEHICLE]: state => {
    state.replaceVehicle.category = null;
    state.replaceVehicle.productCode = null;
    state.replaceVehicle.vehicle = {};
    state.replaceVehicle.driver = {};
    state.replaceVehicle.repairShop = {};
    state.replaceVehicle.managmentShop = {};
    state.replaceVehicle.comment = {};
  },

  [GET_NOTIFICATIONS]: (state, resp) => {
    state.notifications = resp;
  },

  [SEND_NOTIFICATION_READED]: (state, notificationId) => {
    state.notifications = state.notifications.map(notification => {
      if (notification.id === notificationId) {
        return { ...notification, READ: true };
      }
      return notification;
    });
  },

  [GET_OPERATIONS_CARD_FUEL]: (state, resp) => {
    state.operationsCardFuel = resp;
  },

  [GET_INFO_USER]: (state, resp) => {
    state.infoUser = resp;
  },
  [SET_INFO_USER]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },
  [UPDATE_TOWNS_BY_CP_CACHE]: (state, { cp, towns }) => {
    state.townsCache[cp] = towns;
  },

  [SET_VEHICLE_SELECTED]: (state, { vehicleSelected }) => {
    state.vehicleSelected = vehicleSelected;
  },

  [OFFER_LEGAL_CONDITIONS]: (state, conditions) => {
    state.legalConditions = conditions;
  },

  [GET_AUTOLOGIN]: (state, resp) => {
    state.urlIAldPitStop = resp.redirectUrl;
  },
  [UPDATE_TOWNS_BY_PROVINCE_CODE_CACHE]: (state, { provinceCode, towns }) => {
    state.townsProvinceCodeCache[provinceCode] = towns;
  }
};
